import { OperationVariables } from '@apollo/client';
import {
  registerOperation,
  RegisterQueryInput,
  RegisteredQuery,
} from './shared';

function registerQuery<
  TFieldName extends string,
  TVariables extends Record<string, any>,
  TResponse,
>(
  options: RegisterQueryInput<TFieldName, TVariables, TResponse>
): RegisteredQuery<'result', TVariables, TResponse> {
  return registerOperation('query', options, true);
}

function registerMutation<
  TFieldName extends string,
  TVariables extends OperationVariables,
  TResponse,
>(
  options: RegisterQueryInput<TFieldName, TVariables, TResponse>
): RegisteredQuery<'result', TVariables, TResponse> {
  return registerOperation('mutation', options, true);
}

export { registerQuery, registerMutation };
